/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outdatedbrowser_Title1Inputs */

const en_outdatedbrowser_title1 = /** @type {(inputs: Outdatedbrowser_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your browser is out of date`)
};

/**
* | output |
* | --- |
* | "Your browser is out of date" |
*
* @param {Outdatedbrowser_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const outdatedbrowser_title1 = /** @type {((inputs?: Outdatedbrowser_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outdatedbrowser_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outdatedbrowser_title1(inputs)
});
export { outdatedbrowser_title1 as "outdatedBrowser_title" }